import React, {useState} from "react";
import FilterForm from "../../../component/FilterForm/FilterForm";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import SelectInput from "../../../component/SelectInput";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {aliasRoles} from "./aliasRoles";
import {ApiUrl} from "../../../auth/authMethods";
import InputMask from "react-input-mask";
import Typography from "@mui/material/Typography";
import {Switch} from "@mui/material";
import {validateCpf} from "../../../utils/validateCpf";
import {validateCnpj} from "../../../utils/validateCnpj";

export default function FilterFormUsers({filter, setFilter, setLoadData, setPage}) {

    const [lgShow, setLgShow] = useState(false);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [nomeParticipante, setNomeParticipante] = useState('');
    const [role, setRole] = useState('')
    const [isEnabled, setIsEnabled] = useState('');
    const [isAccountNonExpired, setIsAccountNonExpired] = useState('');
    const [roleList, setRoleList] = useState([])
    const [documento, setDocumento] = useState('');

    const [isCnpj, setIsCnpj] = useState(false)

    const handlesSubmit = (e) => {
        e.preventDefault();

        setFilter({
            ...(username && {username}),
            ...(email && {email}),
            ...(role && {role}),
            ...(documento && {documento}),
            ...(isEnabled && {isEnabled}),
            ...(isAccountNonExpired && {isAccountNonExpired}),
            ...(nomeParticipante && {nomeParticipante}),
            ...(phoneNumber && {phoneNumber}),
        });

        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const clearFilter = () => {
        setUsername('')
        setEmail('')
        setNomeParticipante('')
        setRole('')
        setIsEnabled('')
        setIsAccountNonExpired('')
        setPhoneNumber('')
        setIsCnpj(false)
        setFilter({});
        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const toggleSwitch = () => {
        setIsCnpj(prevState => !prevState)
        setDocumento('')
    }

    const InputLabelProps = {
        style: {
            zIndex: 0
        },
    }

    return <>
        <FilterForm
            handleSubmit={handlesSubmit} clearFilter={clearFilter}
            lgShow={lgShow} setLgShow={setLgShow}
            showSecondaryButton={Object.keys(filter).length !== 0}
        >
            <TextField
                label="Usuário do Sistema"
                inputProps={{
                    maxLength: 25
                }}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
                autoFocus
            />
            <TextField
                label="E-mail"
                inputProps={{
                    maxLength: 45
                }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
            />
            <TextField
                label="Nome do Usuário"
                inputProps={{
                    maxLength: 45
                }}
                value={nomeParticipante}
                onChange={(e) => setNomeParticipante(e.target.value)}
                fullWidth
            />

            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {/*<div style={{marginRight: '10px'}}>*/}
                <Typography variant="body1">
                    <b>Documento: &nbsp;</b>
                </Typography>
                <Typography variant="body1">
                    CPF
                </Typography>
                <Switch
                    checked={isCnpj}
                    onChange={toggleSwitch}
                    color="primary"
                    inputProps={{'aria-label': 'alternar entre CNPJ e CPF'}}
                />
                <Typography variant="body1">
                    CNPJ
                </Typography>
            </div>

            {!isCnpj ?
                <InputMask mask="999.999.999-99" value={documento} maskChar={null}
                           onChange={(e) => setDocumento(e.target.value)}>
                    {() =>
                        <TextField
                            label="CPF de um participante" variant="outlined"
                            error={documento.length === 14 && !validateCpf(documento)}
                            helperText={documento.length === 14 && !validateCpf(documento) ? 'CPF inválido' : ''}
                            inputProps={{
                                maxLength: 14,
                                minLength: 14,
                            }}
                            fullWidth
                            InputLabelProps={InputLabelProps}
                        />}
                </InputMask> :
                <InputMask mask="99.999.999/9999-99" value={documento} maskChar={null}
                           onChange={(e) => setDocumento(e.target.value)}>
                    {() =>
                        <TextField
                            label="CNPJ de um participante" variant="outlined"
                            error={documento.length === 18 && !validateCnpj(documento)}
                            helperText={documento.length === 18 && !validateCnpj(documento) ? 'CNPJ inválido' : ''}
                            inputProps={{
                                maxLength: 18,
                                minLength: 18,
                            }}
                            fullWidth
                            InputLabelProps={InputLabelProps}
                        />}
                </InputMask>
            }

            <InputMask mask="(99) 99999-9999" value={phoneNumber} maskChar={null}
                       onChange={(e) => setPhoneNumber(e.target.value)}>
                {() =>
                    <TextField
                        label="Telefone"
                        variant="outlined"
                        inputProps={{
                            maxLength: 15,
                            minLength: 15,
                        }}
                        fullWidth
                    />}
            </InputMask>
            <SelectInput
                url={ApiUrl + '/role?size=2000'}
                list={roleList} set={setRoleList}
                setObj={setRole}
                defaultValue={role}
                returnList={() => {
                    let returnList = []
                    roleList.forEach((item) => {
                        returnList.push({
                            value: item.id,
                            label: aliasRoles.filter(alias => alias.received === item.name)[0].display
                        })
                    })
                    return returnList
                }}
                placeholder={"Tipo de usuário"}
                required={false}
                isClearable
                fullWidth
            />
            <FormControl>
                <FormLabel>Usuário ativo</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={isEnabled}
                    onChange={(e) => setIsEnabled(e.target.value)}
                >
                    <FormControlLabel value={''} control={<Radio/>} label="Todos"/>
                    <FormControlLabel value={true} control={<Radio/>} label="Apenas Ativos"/>
                    <FormControlLabel value={false} control={<Radio/>} label="Apenas Inativos"/>
                </RadioGroup>
            </FormControl>
            <FormControl>
                <FormLabel>Conta expirada</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={isAccountNonExpired}
                    onChange={(e) => setIsAccountNonExpired(e.target.value)}
                >
                    <FormControlLabel value={''} control={<Radio/>} label="Ambos"/>
                    <FormControlLabel value={true} control={<Radio/>} label="Não"/>
                    <FormControlLabel value={false} control={<Radio/>} label="Sim"/>
                </RadioGroup>
            </FormControl><br/>
        </FilterForm>
    </>


}